import { useEffect, type RefObject } from 'react';
import { attachMagnetic, attachPointerLight } from '../effects/pointer.ts';

export function usePointerLight(ref: RefObject<HTMLElement | null>, maxTiltDeg?: number): void {
  useEffect(() => {
    const element = ref.current;
    return element ? attachPointerLight(element, maxTiltDeg) : undefined;
  }, [ref, maxTiltDeg]);
}

export function useMagnetic(ref: RefObject<HTMLElement | null>): void {
  useEffect(() => {
    const element = ref.current;
    return element ? attachMagnetic(element) : undefined;
  }, [ref]);
}
